import { Navigate, Route, Routes } from "react-router-dom";
import PortalLayout from "../layouts/portal";

// routes
import SignInPage from "pages/dashboard/signIn";
import PrivateRoute from "./PrivateRoute";
import generalRoutes from "./routes/generalRoutes";
import protectedRoutes from "./routes/protectedRoutes";
import DashboardLayout from "layouts/dashboard";

const RouterList = () => {
  return (
    <Routes>
      <Route path="/lookup" element={<PortalLayout />}>
        {generalRoutes.map((route, index) =>
          route.Component ? (
            <Route index={index === 0} key={index} path={route.path} element={<route.Component />} />
          ) : null,
        )}
        <Route path="/lookup" element={<Navigate to="/lookup/404" replace />} />
      </Route>

      <Route path="/dashboard" element={<PrivateRoute />}>
        <Route path="" element={<Navigate to="certificate/template/list" replace />} />
        <Route element={<DashboardLayout />}>
          {protectedRoutes.map((route, index) =>
            route.Component ? (
              <Route index={index === 0} key={index} path={route.path} element={<route.Component />} />
            ) : null,
          )}
        </Route>
        <Route path="*" element={<Navigate to="certificate/template/list" replace />} />
        <Route path="sign-in" element={<SignInPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/lookup/404" replace />} />
    </Routes>
  );
};

export default RouterList;
